// AUTO-GENERATED by scripts/gen-budget-icon-map.js - do not edit by hand.
// Regenerate after changing ICON_ALLOWLIST in
// backend/layers/utils/utils/budgetIconAllowlist.js:  node scripts/gen-budget-icon-map.js
//
// Maps a stored budget icon name (picked by the backend in #1126) to its
// @tabler/icons-react component. Part 2 of #1124. Imports are named (not a
// namespace import) so only these 217 icons land in the bundle.
import {
  IconAbacus,
  IconAnchor,
  IconApple,
  IconArmchair,
  IconBabyBottle,
  IconBabyCarriage,
  IconBackpack,
  IconBaguette,
  IconBallBasketball,
  IconBallFootball,
  IconBalloon,
  IconBallpen,
  IconBallTennis,
  IconBarbell,
  IconBasket,
  IconBath,
  IconBeach,
  IconBed,
  IconBeer,
  IconBike,
  IconBolt,
  IconBone,
  IconBook,
  IconBooks,
  IconBottle,
  IconBrandNetflix,
  IconBrandSpotify,
  IconBread,
  IconBriefcase,
  IconBrush,
  IconBuilding,
  IconBuildingBank,
  IconBuildingChurch,
  IconBuildingCircus,
  IconBuildingCottage,
  IconBuildingSkyscraper,
  IconBuildingStore,
  IconBulb,
  IconBurger,
  IconBus,
  IconBusinessplan,
  IconCake,
  IconCalendarEvent,
  IconCamera,
  IconCampfire,
  IconCandy,
  IconCar,
  IconCarCrash,
  IconCarrot,
  IconCarSuv,
  IconCash,
  IconCashBanknote,
  IconCat,
  IconCertificate,
  IconChargingPile,
  IconChartLine,
  IconChartPie,
  IconCheese,
  IconChefHat,
  IconClock,
  IconCoffee,
  IconCoin,
  IconCoins,
  IconCompass,
  IconConfetti,
  IconCookie,
  IconCreditCard,
  IconCross,
  IconCup,
  IconCurrencyDollar,
  IconDental,
  IconDeviceDesktop,
  IconDeviceGamepad,
  IconDeviceGamepad2,
  IconDeviceLaptop,
  IconDeviceMobile,
  IconDeviceTv,
  IconDeviceWatch,
  IconDog,
  IconDroplet,
  IconEgg,
  IconEye,
  IconEyeglass,
  IconFeather,
  IconFirstAidKit,
  IconFish,
  IconFishHook,
  IconFlame,
  IconFlower,
  IconFolderDollar,
  IconFridge,
  IconGardenCart,
  IconGasStation,
  IconGavel,
  IconGift,
  IconGiftCard,
  IconGlassFull,
  IconGolf,
  IconGrill,
  IconHammer,
  IconHanger,
  IconHeadphones,
  IconHeadphonesFilled,
  IconHeadset,
  IconHeart,
  IconHeartbeat,
  IconHeartHandshake,
  IconHome,
  IconHome2,
  IconIceCream,
  IconIceCream2,
  IconJacket,
  IconKarate,
  IconKey,
  IconLamp,
  IconLeaf,
  IconLemon,
  IconLemon2,
  IconLuggage,
  IconMail,
  IconMap,
  IconMap2,
  IconMapPin,
  IconMassage,
  IconMeat,
  IconMedicalCross,
  IconMicrowave,
  IconMilk,
  IconMoneybag,
  IconMoodKid,
  IconMoodSmile,
  IconMotorbike,
  IconMountain,
  IconMovie,
  IconMushroom,
  IconMusic,
  IconNotebook,
  IconNurse,
  IconPaint,
  IconParking,
  IconPaw,
  IconPencil,
  IconPencilPlus,
  IconPepper,
  IconPercentage,
  IconPerfume,
  IconPhone,
  IconPhoto,
  IconPigMoney,
  IconPill,
  IconPills,
  IconPizza,
  IconPlane,
  IconPlaneDeparture,
  IconPlant,
  IconPlant2,
  IconPlug,
  IconPool,
  IconRazor,
  IconReceipt,
  IconReceipt2,
  IconReceiptTax,
  IconRecycle,
  IconReportMoney,
  IconRoad,
  IconRouter,
  IconRuler,
  IconRun,
  IconSailboat,
  IconSalad,
  IconScale,
  IconSchool,
  IconScissors,
  IconScooter,
  IconShield,
  IconShieldCheck,
  IconShip,
  IconShirt,
  IconShirtSport,
  IconShoe,
  IconShoppingBag,
  IconShoppingCart,
  IconShovel,
  IconSofa,
  IconSoup,
  IconSpray,
  IconStethoscope,
  IconStretching,
  IconSwimming,
  IconTax,
  IconTent,
  IconTicket,
  IconToiletPaper,
  IconTool,
  IconTools,
  IconToolsKitchen,
  IconToolsKitchen2,
  IconToolsKitchen3,
  IconTrain,
  IconTrash,
  IconTree,
  IconTrees,
  IconTruck,
  IconUmbrella,
  IconUmbrellaClosed,
  IconUser,
  IconUsers,
  IconVaccine,
  IconVacuumCleaner,
  IconVideo,
  IconWallet,
  IconWashMachine,
  IconWheel,
  IconWheelchair,
  IconWifi,
  IconWorld,
  IconYoga,
} from '@tabler/icons-react';

/** Render default for a budget with no stored (or unknown) icon. */
export const BudgetIconFallback = IconFolderDollar;

const BUDGET_ICONS = {
  IconAbacus,
  IconAnchor,
  IconApple,
  IconArmchair,
  IconBabyBottle,
  IconBabyCarriage,
  IconBackpack,
  IconBaguette,
  IconBallBasketball,
  IconBallFootball,
  IconBalloon,
  IconBallpen,
  IconBallTennis,
  IconBarbell,
  IconBasket,
  IconBath,
  IconBeach,
  IconBed,
  IconBeer,
  IconBike,
  IconBolt,
  IconBone,
  IconBook,
  IconBooks,
  IconBottle,
  IconBrandNetflix,
  IconBrandSpotify,
  IconBread,
  IconBriefcase,
  IconBrush,
  IconBuilding,
  IconBuildingBank,
  IconBuildingChurch,
  IconBuildingCircus,
  IconBuildingCottage,
  IconBuildingSkyscraper,
  IconBuildingStore,
  IconBulb,
  IconBurger,
  IconBus,
  IconBusinessplan,
  IconCake,
  IconCalendarEvent,
  IconCamera,
  IconCampfire,
  IconCandy,
  IconCar,
  IconCarCrash,
  IconCarrot,
  IconCarSuv,
  IconCash,
  IconCashBanknote,
  IconCat,
  IconCertificate,
  IconChargingPile,
  IconChartLine,
  IconChartPie,
  IconCheese,
  IconChefHat,
  IconClock,
  IconCoffee,
  IconCoin,
  IconCoins,
  IconCompass,
  IconConfetti,
  IconCookie,
  IconCreditCard,
  IconCross,
  IconCup,
  IconCurrencyDollar,
  IconDental,
  IconDeviceDesktop,
  IconDeviceGamepad,
  IconDeviceGamepad2,
  IconDeviceLaptop,
  IconDeviceMobile,
  IconDeviceTv,
  IconDeviceWatch,
  IconDog,
  IconDroplet,
  IconEgg,
  IconEye,
  IconEyeglass,
  IconFeather,
  IconFirstAidKit,
  IconFish,
  IconFishHook,
  IconFlame,
  IconFlower,
  IconFolderDollar,
  IconFridge,
  IconGardenCart,
  IconGasStation,
  IconGavel,
  IconGift,
  IconGiftCard,
  IconGlassFull,
  IconGolf,
  IconGrill,
  IconHammer,
  IconHanger,
  IconHeadphones,
  IconHeadphonesFilled,
  IconHeadset,
  IconHeart,
  IconHeartbeat,
  IconHeartHandshake,
  IconHome,
  IconHome2,
  IconIceCream,
  IconIceCream2,
  IconJacket,
  IconKarate,
  IconKey,
  IconLamp,
  IconLeaf,
  IconLemon,
  IconLemon2,
  IconLuggage,
  IconMail,
  IconMap,
  IconMap2,
  IconMapPin,
  IconMassage,
  IconMeat,
  IconMedicalCross,
  IconMicrowave,
  IconMilk,
  IconMoneybag,
  IconMoodKid,
  IconMoodSmile,
  IconMotorbike,
  IconMountain,
  IconMovie,
  IconMushroom,
  IconMusic,
  IconNotebook,
  IconNurse,
  IconPaint,
  IconParking,
  IconPaw,
  IconPencil,
  IconPencilPlus,
  IconPepper,
  IconPercentage,
  IconPerfume,
  IconPhone,
  IconPhoto,
  IconPigMoney,
  IconPill,
  IconPills,
  IconPizza,
  IconPlane,
  IconPlaneDeparture,
  IconPlant,
  IconPlant2,
  IconPlug,
  IconPool,
  IconRazor,
  IconReceipt,
  IconReceipt2,
  IconReceiptTax,
  IconRecycle,
  IconReportMoney,
  IconRoad,
  IconRouter,
  IconRuler,
  IconRun,
  IconSailboat,
  IconSalad,
  IconScale,
  IconSchool,
  IconScissors,
  IconScooter,
  IconShield,
  IconShieldCheck,
  IconShip,
  IconShirt,
  IconShirtSport,
  IconShoe,
  IconShoppingBag,
  IconShoppingCart,
  IconShovel,
  IconSofa,
  IconSoup,
  IconSpray,
  IconStethoscope,
  IconStretching,
  IconSwimming,
  IconTax,
  IconTent,
  IconTicket,
  IconToiletPaper,
  IconTool,
  IconTools,
  IconToolsKitchen,
  IconToolsKitchen2,
  IconToolsKitchen3,
  IconTrain,
  IconTrash,
  IconTree,
  IconTrees,
  IconTruck,
  IconUmbrella,
  IconUmbrellaClosed,
  IconUser,
  IconUsers,
  IconVaccine,
  IconVacuumCleaner,
  IconVideo,
  IconWallet,
  IconWashMachine,
  IconWheel,
  IconWheelchair,
  IconWifi,
  IconWorld,
  IconYoga,
};

/** The icon names this map can render (the backend allowlist, sorted). */
export const BUDGET_ICON_NAMES = Object.keys(BUDGET_ICONS);

/**
 * Resolve a stored budget icon name to a Tabler component. A missing or unknown
 * name falls back to the placeholder (IconFolderDollar).
 *
 * @param {string} [name] - stored budget.icon value
 * @returns {React.ComponentType} a Tabler icon component
 */
export function resolveBudgetIcon(name) {
  return BUDGET_ICONS[name] || BudgetIconFallback;
}
